import Service from 'core/service'
import type { IClientParams } from 'interfaces'

export class ClientService extends Service {
  getListClients(params: any): Promise<ClientModel[]> {
    return this.get('/clients', params)
  }
  createClient(params: any): Promise<ClientModel> {
    return this.post('/clients', params)
  }
  updateClient(params: IClientParams): Promise<ClientModel> {
    return this.put(`/clients/${params.id}/${params.divisionId}`, params)
  }
  deleteClient(params: IClientParams): Promise<ClientModel> {
    return this.delete(`/clients/${params.id}/${params.divisionId}`)
  }
  getClient(params: IClientParams): Promise<ClientModel> {
    return this.get(`/clients/${params.id}/${params.divisionId}`)
  }
}
